import { render, staticRenderFns } from "./MasterResourceList.vue?vue&type=template&id=f2f5007e&scoped=true"
import script from "./MasterResourceList.vue?vue&type=script&lang=js"
export * from "./MasterResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f5007e",
  null
  
)

export default component.exports